// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1ux9o","buttons":"PendingPaymentAlert_buttons__3FBaA"};